import type { Media as RosMedia } from '@carvia/ros-client-types';
import { ServerSentEventService } from './server-sent-event.service';

export type MediaStatusEventDto = {
  media: RosMedia;
};

export const mediaStatusEventsService = () =>
  new ServerSentEventService<MediaStatusEventDto>('/media/events');
